/**
 * Panel Provider Configuration Templates
 *
 * This file defines templates for external panel providers
 * to simplify redirect URL configuration.
 */

export interface PanelProviderTemplate {
  id: string;
  name: string;
  redirectBaseUrl: string;
  trackingParamName: string;
  completionParams: string;
  screenOutParams: string;
  quotaFullParams: string;
}

export const PANEL_PROVIDERS: Record<string, PanelProviderTemplate> = {
  userinterviews: {
    id: 'userinterviews',
    name: 'User Interviews',
    redirectBaseUrl: 'https://www.userinterviews.com/project-task-events/custom_link_with_redirect/complete',
    trackingParamName: 'iid',
    completionParams: '',
    screenOutParams: '',
    quotaFullParams: ''
  },
  dynata: {
    id: 'dynata',
    name: 'Dynata',
    redirectBaseUrl: 'https://dkr1.ssisurveys.com/projects/end',
    trackingParamName: 'psid',
    completionParams: 'rst=1, basic=YYYY',
    screenOutParams: 'rst=2',
    quotaFullParams: 'rst=3'
  },
  custom: {
    id: 'custom',
    name: 'Custom',
    redirectBaseUrl: '',
    trackingParamName: '',
    completionParams: '',
    screenOutParams: '',
    quotaFullParams: ''
  }
};